import axios from 'axios';

interface IUbsGuideMapping {
  lastUpdate?: number;
  mapLocations?: any[];
  mapPostalCodes?: any[];
}

export const fetchUbsGuideMappings = async (): Promise<any[]> => {
  // First check if we already have data
  const existingPostalCodes = window._HG_UBS_GUIDE_MAPPING_?.mapPostalCodes || null;
  if (existingPostalCodes) {
    return existingPostalCodes;
  }

  const guideMappings: IUbsGuideMapping = await loadDataFromAssets();
  const mapPostalCodes = guideMappings?.mapPostalCodes ?? [];

  // Update the data in global window scope
  window._HG_UBS_GUIDE_MAPPING_ = {
    mapPostalCodes,
  };

  return mapPostalCodes;
};

export const loadDataFromAssets = async (): Promise<IUbsGuideMapping> => {
  try {
    const response = await axios.get<IUbsGuideMapping>(
      `${import.meta.env.VUE_UBS_MUNICIPALITY_GUIDE_MAPPING_URL}`,
      {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      },
    );
    return response.data;
  } catch (_) {
    return {};
  }
};
